import * as z from "zod";

export const ButtonTargetSchema = z
  .discriminatedUnion("type", [
    z.object({
      type: z.literal("customUrl"),
      configuration: z.object({ url: z.string().optional() }),
    }),
    z.object({
      type: z.literal("inboxArticle"),
      configuration: z.object({ articleId: z.string().optional() }),
    }),
    z.object({
      type: z.literal("inboxPoll"),
      configuration: z.object({ articleId: z.string().optional() }),
    }),
    z.object({
      type: z.literal("ingameStore"),
    }),
    z.object({
      type: z.literal("makeSso"),
      configuration: z.object({ url: z.string().optional() }).nullish(),
    }),
    z.object({
      type: z.literal("eventPlatform"),
    }),
    z.object({
      type: z.literal("deepLink"),
      configuration: z.object({ url: z.string().optional() }),
    }),

    // Deprecated (but we still have this type of content, so we need to support it)
    z.object({
      type: z.literal("make"),
      configuration: z.object({ url: z.string().optional() }).nullish(),
    }),
  ])
  .nullable();

export type ButtonTarget = z.infer<typeof ButtonTargetSchema>;
